import {defineComponent, h, PropType} from 'vue';
import rangeNode from './rangeNode';

export default defineComponent({
    props: {
        count: {
            type: Number as PropType<number>,
            required: false,
            default: 5,
        },
        size: {
            type: Number as PropType<number>,
            required: false,
            default: 10,
        },
        bg: {
            type: String as PropType<string>,
            required: false,
            default: 'gray',
        },
        selectNode: {
            type: Number as PropType<number>,
            required: false,
            default: 0,
        },
        lineColor: {
            type: String as PropType<string>,
            default: 'var(--identity)',
            required: false,
        },
        transition: {
            type: Number as PropType<number>,
            default: 0.5,
            required: false,
        },
        textColor: {
            type: String,
            default: "black",
            required: false,
        },
        placeNodeLeft: {
            type: Number as PropType<number>,
            required: false,
            default: 0,
        },
        placeNodeRight: {
            type: Number as PropType<number>,
            required: false,
            default: 0,
        },
        width: {
            type: Number as PropType<number>,
            required: false,
            default: 0,
        },
    },
    render(props: {
        count: number,
        size: number,
        bg: string,
        selectNode: number,
        lineColor: string,
        transition: number,
        width: number,
        placeNodeLeft: number,
        placeNodeRight: number,
        textColor: string
    }) {
        const inc = 100 / props.count;
        return Array.from({length: props.count + 1}).map(
            ((left) => (_) => {
                left += inc;
                if (props.placeNodeLeft <= left && props.placeNodeRight >= left) {
                    return h(rangeNode, {
                        size: props.size,
                        bg: props.lineColor,
                        left,
                    });
                } else {
                    return h(rangeNode, {
                        size: props.size,
                        bg: props.bg,
                        left,
                    });
                }
            })(-inc),
        );
    },
});
